
  import { Component, Vue, Watch, Emit } from 'vue-property-decorator'
  import { mapGetters } from 'vuex'
  import QuestionContent from './QuestionContentComponent.vue'
  import { State, Getter, Action, Mutation } from '../store-helper'
  import AnswerItem from '../../../common/AnswerItem'
  import { IAnswerItem, IQuestion } from '../../../types'
  import { IAnswer } from '../types'
  import { getGroupQuestion, checkAnsweredGroup, checkBlankGroupQuestion } from '../../../lib/group-question'

  @Component({
    components: {
      QuestionContent
    }
  })

  export default class QuestionGroupComponent extends Vue {
    @Getter currentQuestions: IQuestion<IAnswerItem>[]
    @Getter totalQuestionGroup: number
    @State currentQuestionIndex: number
    @State questions: IQuestion<IAnswerItem>[]
    @State answers: IAnswer[]
    @State timer: number
    @Action submit
    @Action changeQuestion
    @Mutation nextQuestion
    @Mutation showQuestion
    @Mutation prevQuestion

    updated () {
      this.$nextTick(() => {
        let changeQuestionByHistory = this.showQuestion
        window.onpopstate = () => {
          let current_question = location.href.split("-").pop()
          if(!isNaN(Number(current_question))){
            changeQuestionByHistory({index: Number(current_question)})
          }
        }
        let elm = (<Element> window.document.querySelector("#mainContent"))
        if(window.document.querySelector(".custom-ckeditor")){
          elm.setAttribute("style", `height: auto`)
        }
        else{
          let topHeight = elm.getBoundingClientRect().top + 100
          elm.setAttribute("style", `height: calc(100vh - ${topHeight}px)`)
        }
      })
    }

    public answerQuestion() {
      const components = this.$refs["question_content"]
      const componentPromises = []
      const oldQuestionIndex = this.currentQuestionIndex
      for (let index in components) {
        componentPromises.push(components[index].answerQuestion())
      }
      Promise.all(componentPromises).then(() => {
        if (this.currentQuestionIndex == oldQuestionIndex) this.nextQuestion()
      })
      this.nextQuestion()
    }

    public get groupQuestions(): IQuestion<IAnswerItem>[][]{
      return getGroupQuestion(this.questions);
    }

    public get blankQuestion(): boolean {
      return this.isBlankGroupQuestion(this.currentQuestions)
    }

    public isBlankGroupQuestion(questions: IQuestion<IAnswerItem>[]): boolean {
      return checkBlankGroupQuestion(questions)
    }

    public isAnsweredGroup(questions: IQuestion<IAnswerItem>[]): boolean{
      return checkAnsweredGroup(questions, this.answers)
    }

    public get answeredTotal(): number{
      let total = 0
      const groupQuestions = this.groupQuestions
      for (let i = 0; i < groupQuestions.length; i++) {
        let groupQuestion = <{}>groupQuestions[i]
        if(checkAnsweredGroup(groupQuestion["questions"], this.answers)){
          total += 1;
        }
      }
      return total;
    }

    public get questionTotal(): number{
      let total = 0
      const groupQuestions = this.groupQuestions
      for (let i = 0; i < groupQuestions.length; i++) {
        let groupQuestion = <{}>groupQuestions[i]
        if(!this.isBlankGroupQuestion(groupQuestion["questions"])){
          total += 1;
        }
      }
      return total;
    }

    public get questionTitle(): string{
      let quesiton_group = this.groupQuestions[this.currentQuestionIndex]
      let question_num = quesiton_group && quesiton_group["question_index"]
      if(question_num)
        return "問題" + question_num
      else if(!this.isSubmitPage)
        return "説明"
      else
        return "テストの提出"
    }

    public get answeredRate(): number {
     if (this.questionTotal == 0) return 100
     return Number(this.answeredTotal / this.questionTotal * 100)
    }

    public get isSubmitPage(): boolean {
      return this.currentQuestionIndex >= this.totalQuestionGroup
    }

    public nextQuestionEvent(){
      if(!this.isSubmitPage){
        this.changeQuestion({index: this.currentQuestionIndex+1})
      }
    }

    @Watch('currentQuestions')
    oncurrentQuestionsChanged(currentQuestions: IQuestion<IAnswerItem>[]) {
      this.$nextTick(() => {
        let components = this.$refs["question_content"]
        for (let index in components) {
          components[index].fillValue()
        }
        let forms = self.document.getElementById("editor-preview").getElementsByTagName("form")
        Array.from(forms).forEach( (form) => {
          form.addEventListener("submit", function(event){
            event.preventDefault();
          }, false);
        });
      })
    }
  }
